import type { ToccoSeminarFieldsFragment } from '~/api/graphql/generated'
import type { ParsedToccoModuleFieldsFragment } from '~/types'

export type SeminarCartModule = ParsedToccoModuleFieldsFragment & {
  optional?: boolean
  eLearningModule?: boolean
}

export interface SeminarCartProps {
  seminar: ToccoSeminarFieldsFragment | null
  modules: SeminarCartModule[]
}

export const useSeminarCartStore = defineStore('SeminarCart', {
  state: () => ({ seminar: null, modules: [] }) as SeminarCartProps,
  getters: {},
  actions: {
    setModules(modules: SeminarCartModule[]) {
      this.modules = modules
    },

    addModule(module: SeminarCartModule) {
      this.modules.push(module)
    },

    removeModule(module: SeminarCartModule) {
      const key = this.modules.findIndex((currentModule: SeminarCartModule) => currentModule.id === module.id)
      if (key !== -1) {
        this.modules.splice(key, 1)
      }
    },

    clearModules() {
      this.modules = []
    },

    setSeminar(seminar: ToccoSeminarFieldsFragment) {
      this.seminar = seminar
    },

    clearSeminar() {
      this.seminar = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSeminarCartStore, import.meta.hot))
}
